import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryCards from './components/CategoryCards';
import ArticlePreview from './components/ArticlePreview';
import ArticlesGrid from './components/ArticlesGrid';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <CategoryCards />
      <ArticlePreview />
      <ArticlesGrid />
      <Footer />
    </div>
  );
}